<template>
    <div>
        <div v-if="vo.id">
            <el-form :model="vo">
            <div style="width: 100%" class="el-table el-table--fit el-table--border">
                <div class="el-table__body-wrapper">
                <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                    <tbody>
                    <tr>
                        <td ref="tdlbl_会议议题" class="el-table__cell tdlbl tdw17" colspan="1">
                            <span class="required">*</span>
                            <span v-field-lbl="'flSubject'" class="field">会议议题</span>
                        </td>
                        <td class="el-table__cell tdcont tdw83" colspan="5">
                            <div style="line-height: 26px">{{ vo.flSubject }}</div>
                        </td>
                    </tr>
                    <tr>
                        <td ref="tdlbl_会议时间" class="el-table__cell tdlbl tdw17" colspan="1">
                            <span class="required">*</span>
                            <span v-field-lbl="'meetingTime2'" class="field">会议时间</span>
                        </td>
                        <td class="el-table__cell tdcont tdw33" colspan="2">
                            <template v-if="canEdit">
                                <el-date-picker v-model="datePickerValue" style="width: 100%" type="datetimerange" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" @change="datePickerChange"></el-date-picker>
                            </template>
                            <template v-else>
                                <div style="line-height: 26px">{{ datePickerValue[0] | formatTime }} 至 {{ datePickerValue[1] | formatTime }}</div>
                            </template>
                        </td>
                        <td ref="tdlbl_会议地点" class="el-table__cell tdlbl tdw17" colspan="1">
                            <span class="required">*</span>
                            <span v-field-lbl="'meetPlace'" class="field">会议地点</span>
                        </td>
                        <td class="el-table__cell tdcont tdw33" colspan="2">
                            <form-item ref="meetPlace" :field="{ defaultValue: null, elementCanEdit: '{${curTN.tnCanEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 1, elementType: 'input', emptyMessage: '', errorMessage: null, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '会议地点', propName: 'meetPlace', propType: 'String', textFormatter: 'textfield', valueMaxLength: 100, valueMinLength: null, tbFieldName: 'meetplace', iconName: 'puwb', model: 'vo.meetPlace', option: [], formTdAlign: 'text-left', autocomplete: 'off', showWordLimit: false, dialog: 1, dialogType: 'listpage', dialogOrgLevel: '', dialogMultiple: false, dialogListviewurl: 'hygl.meetingRoom.listApprove' }" :vo="vo" :can-edit="canEdit" />
                        </td>
                    </tr>
                    <tr>
                        <td ref="tdlbl_会议类型" class="el-table__cell tdlbl tdw17" colspan="1">
                            <span class="required">*</span>
                            <span v-field-lbl="'meetingTypeName'" class="field">会议类型</span>
                        </td>
                        <td class="el-table__cell tdcont tdw33" colspan="2">
                            <div>{{ vo.meetingTypeName }}</div>
                        </td>

                            <td ref="tdlbl_主办部门" class="el-table__cell tdlbl tdw17" colspan="1">
                            <span v-field-lbl="'mainDept'" class="field">主办部门</span>
                        </td>
                        <td class="el-table__cell tdcont tdw33" colspan="2">
                            <div>{{ vo.mainDept }}</div>
                        </td>
                    </tr>
                    <tr>
                        <td ref="tdlbl_会议主持人" class="el-table__cell tdlbl tdw17" colspan="1">
                        <span class="required">*</span>
                        <span v-field-lbl="'meetHost'" class="field">会议主持人</span>
                        </td>
                        <td class="el-table__cell tdcont tdw83" colspan="5">
                        <form-item ref="meetHost" :field="{ defaultValue: null, elementCanEdit: '{${curTN.tnCanEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入会议主持人', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 12, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '会议主持人', propName: 'meetHost', propType: 'String', textFormatter: 'textfield', valueMaxLength: 20, valueMinLength: null, model: 'vo.meetHost', option: [], autocomplete: 'off', showWordLimit: false, dialog: 1, dialogType: 'staff', dialogOrgLevel: '', dialogSelectedOrderBy: 'orgOrderNo', dialogMultiple: false, dialogOrgSelf: false, dialogOnlyCurSys: true }" :vo="vo" :can-edit="canEdit" />
                        </td>
                    </tr>
                    <tr>
                        <td ref="tdlbl_出席领导" class="el-table__cell tdlbl tdw17" colspan="1">
                        <span class="required">*</span>
                        <span v-field-lbl="'attendLeader'" class="field">出席领导</span>
                        </td>
                        <td class="el-table__cell tdcont tdw83" colspan="5">
                        <form-item ref="attendLeader" :field="{ defaultValue: null, elementCanEdit: '{${curTN.tnCanEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入出席领导', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '出席领导', propName: 'attendLeader', propType: 'String', textFormatter: 'textfield', valueMaxLength: 100, valueMinLength: null, model: 'vo.attendLeader', option: [], autocomplete: 'off', showWordLimit: false, dialog: 1, dialogType: 'staff', dialogOrgLevel: '', dialogSelectedOrderBy: 'orgOrderNo', dialogMultiple: true, dialogOrgSelf: false, dialogOnlyCurSys: true }" :vo="vo" :can-edit="canEdit" />
                        </td>
                    </tr>
                    <tr>
                        <td ref="tdlbl_参会人员" class="el-table__cell tdlbl tdw17" colspan="1">
                            <span class="required">*</span>
                            <span v-field-lbl="'attendName'" class="field">{{ vo.meetShape===1? '参会人员' : '参会部门' }}</span>
                        </td>
                        <td class="el-table__cell tdcont tdw83" colspan="5">
                            <template v-if="vo.meetShape===2">
                                <form-item ref="attendName" :field="{ defaultValue: null, elementCanEdit: '{${curTN.tnCanEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 1, elementType: 'input', emptyMessage: '请输入参会部门', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '参会部门', propName: 'attendName', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.attendName', option: [], autocomplete: 'off', showWordLimit: false, dialog: 1, dialogType: 'suborg', dialogOrgLevel: '', dialogSelectedOrderBy: 'orgOrderNo', dialogMultiple: true, dialogOrgSelf: false, dialogOnlyCurSys: true, tbFieldName: 'attendname' }" :vo="vo" :can-edit="canEdit" />
                            </template>
                            <template v-else>
                                <form-item ref="attendName" :field="{ defaultValue: null, elementCanEdit: '{${curTN.tnCanEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 1, elementType: 'input', emptyMessage: '请输入参会人员', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '参会人员', propName: 'attendName', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.attendName', option: [], autocomplete: 'off', showWordLimit: false, dialog: 1, dialogType: 'staff', dialogOrgLevel: '', dialogSelectedOrderBy: 'orgOrderNo', dialogMultiple: true, dialogOrgSelf: false, dialogOnlyCurSys: true, tbFieldName: 'attendname' }" :vo="vo" :can-edit="canEdit" />
                            </template>
                        </td>
                    </tr>
                    <tr>
                        <td ref="tdlbl_会议纪要人员" class="el-table__cell tdlbl tdw17" colspan="1">
                        <span v-field-lbl="'summaryName'" class="field">会议纪要人员</span>
                        </td>
                        <td class="el-table__cell tdcont tdw33" colspan="2">
                        <form-item ref="summaryName" :field="{ defaultValue: null, elementCanEdit: '{${curTN.tnCanEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入会议纪要人员名称', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '会议纪要人员', propName: 'summaryName', propType: 'String', textFormatter: 'textfield', valueMaxLength: 1073741823, valueMinLength: null, model: 'vo.summaryName', option: [], autocomplete: 'off', showWordLimit: false, dialog: 1, dialogType: 'staff', dialogOrgLevel: '', dialogSelectedOrderBy: 'orgOrderNo', dialogMultiple: false, dialogOrgSelf: false, dialogOnlyCurSys: true }" :vo="vo" :can-edit="canEdit" />
                        </td>
                        <td ref="tdlbl_联系电话" class="el-table__cell tdlbl tdw17" colspan="1">
                        <span v-field-lbl="'summaryPhone'" class="field">联系电话</span>
                        </td>
                        <td class="el-table__cell tdcont tdw33" colspan="2">
                        <form-item ref="summaryPhone" :field="{ defaultValue: null, elementCanEdit: '{${curTN.tnCanEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入纪要人员电话', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '联系电话', propName: 'summaryPhone', propType: 'String', textFormatter: 'textfield', valueMaxLength: 20, valueMinLength: null, model: 'vo.summaryPhone', option: [], autocomplete: 'off', showWordLimit: false }" :vo="vo" :can-edit="canEdit" />
                        </td>
                    </tr>
                    <tr>
                        <td ref="tdlbl_会议内容" class="el-table__cell tdlbl tdw17" colspan="1">
                            <span class="required">*</span>
                            <span v-field-lbl="'flContent'" class="field">会议内容</span>
                        </td>
                        <td class="el-table__cell tdcont tdw83" colspan="5">
                            <form-item ref="flContent" :field="{ defaultValue: null, elementCanEdit: '{${curTN.tnCanEdit}}', elementCssHeight: 70, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'textarea', emptyMessage: '请输入会议内容', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '会议内容', propName: 'flContent', propType: 'String', textFormatter: 'textarea', valueMaxLength: 1073741823, valueMinLength: null, model: 'vo.flContent', option: [], autosize: false }" :vo="vo" :can-edit="canEdit" :autosize="false" />
                        </td>
                    </tr>
                    <tr>
                        <td ref="tdlbl_是否开放签到" class="el-table__cell tdlbl tdw17" colspan="1">
                            <span class="required">*</span>
                            <span v-field-lbl="'flContent'" class="field">是否开放签到</span>
                        </td>
                        <td class="el-table__cell tdcont tdw33" colspan="2">
                            <div>{{ vo.openSgin===1?'是':'否' }}</div>
                        </td>
                        <td ref="tdlbl_是否回执" class="el-table__cell tdlbl tdw17" colspan="1">
                            <span class="required">*</span>
                            <span v-field-lbl="'flContent'" class="field">是否回执</span>
                        </td>
                        <td class="el-table__cell tdcont tdw33" colspan="2">
                            <div>{{ vo.ifReceipt===1?'是':'否' }}</div>
                        </td>
                    </tr>
                    <tr>
                        <td ref="tdlbl_是否有外联人员" class="el-table__cell tdlbl tdw17" colspan="1">
                            <span class="required">*</span>
                            <span v-field-lbl="'flContent'" class="field">是否有外联人员</span>
                        </td>
                        <td class="el-table__cell tdcont tdw33" colspan="2">
                            <div>{{ vo.openExternalPerson===1?'是':'否' }}</div>
                        </td>
                        <td ref="tdlbl_是否添加议程" class="el-table__cell tdlbl tdw17" colspan="1">
                            <span class="required">*</span>
                            <span v-field-lbl="'flContent'" class="field">是否添加议程</span>
                        </td>
                        <td class="el-table__cell tdcont tdw33" colspan="2">
                            <template>
                                <el-radio v-model="vo.openYt" :label="1">是</el-radio>
                                <el-radio v-model="vo.openYt" :label="0">否</el-radio>
                            </template>
                        </td>
                    </tr>
                    <tr v-if="vo.openYt===1" :key="5001">
                        <td ref="tdlbl_会议议题" class="el-table__cell tdlbl tdw17" colspan="1">
                        <span class="required">*</span>
                        <span v-field-lbl="''" class="field">会议议题</span>
                        </td>
                        <td class="el-table__cell tdcont tdw83" colspan="5">
                        <template>
                            <div>
                            <el-button v-if="formatTime" size="small" @click="selectYt">选择会议议程</el-button>
                            <el-button v-if="false" v-listpage-dialog size="small" listviewurl="hygl.meetDirectory.list_form_select" dialog-title="选择会议议程" :multiple="true">选择会议议程</el-button>
                            <div class="hyyt_list">
                                <div v-for="(item, index) in ytList" :key="item.id" style="line-height: 20px">
                                <el-link type="primary" @click="openmlyt(item)">{{ item.text }}</el-link>
                                <!-- <i style="margin-left: 10px" class="el-icon-close" @click="closeHandler(item, index)"></i> -->
                                </div>
                            </div>
                            </div>
                        </template>
                        </td>
                    </tr>
                     <tr v-if="vo.openYt===1" :key="5002">
                        <td ref="tdlbl_随议题列席人员" class="el-table__cell tdlbl tdw17" colspan="1">
                        <span class="required">*</span>
                        <span v-field-lbl="'sAttendName'" class="field">随议题列席人员</span>
                        </td>
                        <td class="el-table__cell tdcont tdw83" colspan="5">
                        <form-item ref="sAttendName" :field="{ defaultValue: null, elementCanEdit: '{${curTN.tnCanEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 1, elementType: 'input', emptyMessage: '请输入随议题列席人员', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '随议题列席人员', propName: 'sAttendName', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.sAttendName', option: [], autocomplete: 'off', showWordLimit: false, dialog: 1, dialogType: 'staff', dialogOrgLevel: '', dialogSelectedOrderBy: 'orgOrderNo', dialogMultiple: true, dialogOrgSelf: false, dialogOnlyCurSys: true }" :vo="vo" :can-edit="canEdit" />
                        </td>
                    </tr>
                    <tr>
                        <td ref="tdlbl_附件 " class="el-table__cell tdlbl tdw17" colspan="1">
                        <span v-field-lbl="'isTop'" class="field">文件附件</span>
                        </td>
                        <td class="el-table__cell tdcont tdw83" colspan="5">
                            <Attachment ref="attachments" :vo="vo" :is-required="0" accept="" empty-message="" wf-attach-url="hygl/hyap" :limit-count="100" online-editor="" online-file="" :attachments="attachs" :attachs-type="'ATTACH'" />
                        </td>
                    </tr>
                    <tr>
                        <td ref="tdlbl_是否立即发送通知 " class="el-table__cell tdlbl tdw17" colspan="1">
                        <span class="required">*</span>
                        <span v-field-lbl="'openYt'" class="field">是否立即发送通知</span>
                        </td>
                        <td class="el-table__cell tdcont tdw83" colspan="5">
                        <div>
                            <template>
                            <el-radio v-model="messageFlag" :label="1">是</el-radio>
                            <el-radio v-model="messageFlag" :label="0">否</el-radio>
                            </template>
                        </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                </div>
            </div>
            </el-form>
        </div>
        <!-- <span slot="footer" class="dialog-footer">
            <el-button @click="hyglxxbgShow = false">{{ $tx('hygl.cancel','取 消') }}</el-button>
            <el-button type="primary" @click="SignforConfirm">{{ $tx('hygl.submit','提 交') }}</el-button>
        </span> -->
        <HytzHyyt />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
const moment = require('moment')
import HytzHyyt from '../../hytzHygl/hytzHyytDialog.vue'
export default {
    components: {
        // topicDetailsHyglBg
        HytzHyyt
    },
    filters: {
        formatTime: function (val) {
            if (val) {
                return moment().format('YYYY-MM-DD HH:mm')
            }
            return val
        }
    },
    props: {
        row: {
            type: Object,
            default: () => {}
        },
        messageFlag: {
            type: Number,
            default: 0
        },
        canEdit: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            i18npkg: 'hygl',
            moduleCode: 'components',
            bfhytzShow: false,
            dialogVisible: false,
            dialogVisibleMlytShow: false,
            hyglxxbgShow: false,
            bftzObj: {
                attendName: null,
                attendId: null,
                meetShape: 1
            },
            doing: false,
            imageUrl: '',
            vo: {},
            ytList: [],
            attachs: null,
            value1: '',
            listdata: [],
            stTime: '', // 选择会议地点储存会议开放开始时间
            enTime: '',
            options6: [],
            // messageFlag: 0,
            tableData: [],
            datePickerValue: [],
            defaultMeetDirectoryIds: '', // 原始的会议目标id
            defaultMarkContent: '',
            wfInstance: {
                id: this.row.id
            }

        }
    },
    computed: {
        ...mapGetters(['loginUser'])
    },
    watch: {
        'bftzObj.meetShape': function (val) {
            this.bftzObj.attendId = null
            this.bftzObj.attendName = null
        },
        'hyglxxbgShow': {
            handle(newVal, oldVal) {
                if (!newVal) {
                    this.vo = {}
                }
            }
        },
        'attachs': {
            handler(newVal, oldVal) {
                this.row.passenger.attachsList = newVal
                console.log('attachs', newVal, this.row)
            }
        }
    },
    created() {
        this.$bus.on('meetInfoFirst', this.meetInfoFirst)
        this.meetInfoFirst(this.row)
    },
    beforeDestroy() {
        this.$bus.off('meetInfoFirst', this.meetInfoFirst)
    },
    mounted() {},
    methods: {
        async SignforConfirm(noresh) {
            console.log('确定', this.vo)
            var stTime = moment(this.vo.startTime).format('YYYY-MM-DD HH:mm')
            var endTime = moment(this.vo.endTime).format('YYYY-MM-DD HH:mm')
            var stTime1 = moment(this.vo.startTime).format('YYYY-MM-DD') + ' ' + this.stTime.substr(11, 5)
            var enTime1 = moment(this.vo.endTime).format('YYYY-MM-DD') + ' ' + this.enTime.substr(11, 5)
            stTime = new Date(stTime).getTime()
            stTime1 = new Date(stTime1).getTime()
            endTime = new Date(endTime).getTime()
            enTime1 = new Date(enTime1).getTime()
            // if (new Date(this.vo.startTime).getTime() < new Date(moment(new Date()).format('YYYY-MM-DD HH:mm')).getTime()) {
            //     this.$alert(this.$tx('hygl.message.meetingLater', '会议室开始时间不得晚于当前时间'), this.$tx('common.operationTip', '操作提示'), { type: 'warning' })
            //     return
            // }
            if (!this.vo.meetPlace) {
                this.$alert('会议地点是必须的。', this.$tx('common.operationTip', '操作提示'), { type: 'warning' })
                return
            }
            if (this.vo.startTime > this.vo.endTime) {
                this.$alert(this.$tx('hygl.message.meetingBegin', '结束时间不能早于开始时间'), this.$tx('common.operationTip', '操作提示'), { type: 'warning' })
                return
            }
            // if (stTime < stTime1 || stTime > endTime || endTime > enTime1) {
            //     this.$alert(this.$tx('hygl.message.meetingBeginTo', '会议室开放时间为') + this.stTime.substr(11, 5) + ' - ' + this.enTime.substr(11, 5), this.$tx('common.operationTip', '操作提示'), { type: 'warning' })
            //     return
            // }
            this.vo.status = 2

            const name = []
            const ids = []
            this.ytList.forEach((item) => {
                name.push(item.text)
                ids.push(item.id)
            })
            this.vo.ytObject = name.join(',')
            this.vo.ytId = ids.join(',')

            var orderNo = 1000
            this.vo.passenger.batchUpdate.forEach(item => {
                item.orderNo = orderNo
                orderNo++
            })
            console.log('确定', this.datePickerValue)

            debugger

            this.$http({
                method: 'post',
                url: `/hygl/hyap/changeInfo?messageFlag=${this.messageFlag}`,
                data: this.vo
            }).then((res) => {
                if (res.code === 'success') {
                    this.hyglxxbgShow = false
                    this.vo = {}
                    this.$bus.emit('refreshListData')
                    this.$message.success(res.message)
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        meetInfoFirst(row) {
            var _this = this
            // row.startTime = row.startTime.substr(0, 16)
            // row.endTime = row.endTime.substr(0, 16)
            console.log('this.row111', this.row)

            this.vo = JSON.parse(JSON.stringify(this.row))
            this.datePickerValue[0] = moment(new Date(this.row.startTime)).format('YYYY-MM-DD HH:mm:ss')
            this.datePickerValue[1] = moment(new Date(this.row.endTime)).format('YYYY-MM-DD HH:mm:ss')
            this.value1 = this.row.meetPlace
            this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                params: {
                    busiDataIds: this.row.id
                },
                url: `/hygl/attach/queryAttachList?urlsearch=orgCode:${this.loginUser.orgCode}`
            }).then((result) => {
                if (result.code === 'success') {
                    this.attachs = result.body.listdata
                } else {
                    this.$message.error(result.message)
                }
            })
            var arr = []
            this.$http({
                method: 'POST',
                url: 'hygl/meetingRoom/querydata',
                data: [{ compare: '=', field: 'orgCode', merge: true, value: this.loginUser.orgCode }],
                params: { orderBy: 'meetName asc' }
            }).then((res) => {
                if (res.code === 'success') {
                    this.listdata = res.body.listdata
                    for (let i = 0; i < res.body.listdata.length; i++) {
                        arr.push({ label: res.body.listdata[i].meetName, value: res.body.listdata[i].id })
                        if (this.listdata[i].meetName === this.row.meetPlace) {
                            this.stTime = this.listdata[i].beginTime // 选择会议地点储存会议开放开始时间
                            this.enTime = this.listdata[i].endTime
                        }
                    }
                    this.options6 = arr
                }
            })

            this.getMeetType().then((result) => {
                if (result.code === 'success') {
                    var list = result.body.listdata
                    _this.meetingTypeNameOptions = list.map((item) => {
                        return {
                            id: item.id,
                            label: item.typeName,
                            value: item.typeName
                        }
                    })

                    _this.vo = JSON.parse(JSON.stringify(this.row))
                    _this.vo.passenger.meetDirectoryIds = '' //  绑定目录
                    _this.vo.passenger.cancelDirectory = '' //  取消绑定会议目录
                    // _this.vo.passenger.relevanceYtRecord = { 'meetDirectoryId': '', 'ytRecordLists': 'yyy,xxx' }, //  添加议题到目录
                    _this.vo.passenger.deleteYtRecord = '', //  删除议题
                    _this.vo.passenger.batchUpdate = [], //  排序议题
                    _this.ytList = []
                    if (_this.vo.ytObject && _this.vo.ytId) {
                        if (_this.vo.ytId.indexOf(',') > -1) {
                            const arr = _this.vo.ytObject.split(',')
                            const ids = _this.vo.ytId.split(',')
                            ids.forEach((item, index) => {
                                _this.ytList.push({ text: arr[index], id: item })
                            })
                        } else {
                            _this.ytList = [{ text: _this.vo.ytObject, id: _this.vo.ytId }]
                        }
                        // _this.vo.passenger.meetDirectoryIds = _this.vo.ytId
                        _this.defaultMeetDirectoryIds = JSON.parse(JSON.stringify(_this.vo.ytId))
                        _this.vo.defaultMeetDirectoryIds = JSON.parse(JSON.stringify(_this.vo.ytId))
                    }
                    _this.hyglxxbgShow = true
                }
            })
        },
        // 获取会议类型
        getMeetType() {
            return new Promise(async(resolve, reject) => {
                // const data = [
                //     { 'compare': '=', 'field': 'status', 'merge': true, 'value': 1 },
                //     { 'compare': '=', 'field': 'orgCode', 'merge': true, 'value': this.loginUser.orgCode }
                // ]
                // const res = await this.$app.querydata('/hygl/type/querydata', data)
                // if (res.code === 'success') {
                //     resolve(res)
                // }
                resolve({ code: 'success', body: { listdata: [] }})
            })
        },
        // 删除会议目录
        closeHandler(item, index) {
            var _this = this
            // this.$http({
            //     method: 'POST',
            //     url: 'hygl/hyapYtInfo/cancelDirectory',
            //     contentType: 'application/x-www-form-urlencoded',
            //     params: {
            //         hyapId: this.vo.id,
            //         meetDirectoryId: item.id
            //     }
            // }).then(res => {
            //     if (res.code === 'success') {
            //         this.ytList.splice(index, 1)
            //     }
            // })
            // 删除
            var temp = []
            if (_this.vo.passenger.cancelDirectory) {
                temp = _this.vo.passenger.cancelDirectory.split(',')
            }
            if (_this.defaultMeetDirectoryIds.indexOf(item.id) > -1) {
                temp.push(item.id)
            }
            if (temp.length) {
                _this.vo.passenger.cancelDirectory = temp.join(',')
            }

            this.ytList.splice(index, 1)
            this.updateMeetDirectoryIds(this.ytList, item.id)
        },
        handleClose(done) {},
        openmlyt(row) {
            // this.$bus.emit('openDialog', this.vo, this.row)
            console.log(this)
            this.$vnode.context.activeName = 'second'
        },
        selectYt() {
            const ids = []
            this.ytList.forEach((item) => {
                ids.push(item.id)
            })
            var el = {
                attrs: {
                    // listviewurl: `hygl.meetDirectory.list?urlsearch=id!:${ids.join(',')};subjectTypeName:${this.vo.meetingTypeName}`,
                    listviewurl: `hygl.meetDirectory.list_form_select?urlsearch=id!:${ids.join(',')};status:1`,
                    'dialog-title': this.$tx('hygl.components.meetingDialogTitle', '选择会议议程'),
                    'exclude-fields': '',
                    'retain-btns': 'addObject,editObject',
                    multiple: false
                }
            }
            const vnode = {
                context: this,
                data: { model: { expression: '' } }
            }
            this.$bus.emit('openListpageDialog', el, null, vnode)
        },
        // 通用列表选择对话框-加载数据前回调
        onDialogListDataBeforeLoad($scope, qparams) {
            console.log($scope.moduleInfo.moduleCode, 'onDialogListDataBeforeLoad')
        },
        // 通用列表选择对话框-加载数据后回调
        onDialogListDataLoaded($scope, pageInfo) {
            pageInfo.list.forEach((item) => {
                item.remark = item.passenger.noMeetProportion
            })
        },
        // 内嵌子表-加载数据后回调
        onInnerTableListDataLoaded($scope, pageInfo) {
            console.log($scope.moduleInfo.moduleCode, 'onInnerTableListDataLoaded')
            pageInfo.list.forEach((item) => {
                item.noMeetProportion = item.passenger.noMeetProportion
            })
        },
        updateMeetDirectoryIds(list, id = '') {
            var idArr = []
            if (!id) {
                if (this.vo.passenger.meetDirectoryIds) {
                    idArr = this.vo.passenger.meetDirectoryIds.split(',')
                    idArr = idArr.filter(item => this.defaultMeetDirectoryIds.indexOf(item.id) !== -1)
                }
                list.forEach((item) => {
                    if (idArr.indexOf(item.id) === -1) idArr.push(item.id)
                })
                if (idArr.length) {
                    this.vo.passenger.meetDirectoryIds = idArr.join(',')
                }
                list.forEach((item) => {
                    this.ytList.push({ text: item.subject, id: item.id })
                })
                this.row.ytId = list.map(item => item.id).join(',')
                this.row.ytObject = list.map(item => item.subject).join(',')
            } else {
                idArr = this.vo.passenger.meetDirectoryIds.split(',')
                idArr = idArr.filter(item => item !== id)
                if (idArr.length) {
                    this.vo.passenger.meetDirectoryIds = idArr.join(',')
                } else {
                    this.vo.passenger.meetDirectoryIds = ''
                }
            }
            console.log('this.vo', this.vo)
            // this.$vnode.context.rowData = this.vo
            this.$vnode.context.rowData.ytId = this.vo.passenger.meetDirectoryIds
            // this.$vnode.context.rowData.ytObject = this.vo.passenger.meetDirectoryIds
            console.log('this', this)

            if (this.ytList.length > 1) {
                this.closeHandler(this.ytList[0], 0)
            }
        },
        onSelectListpageRowCompleted: function (selectedNodes, attr) {
            var _this = this
            if (attr.name === 'meetPlace') {
                _this.vo.meetPlace = selectedNodes[0].meetName
                _this.vo.meetPlaceId = selectedNodes[0].id

                _this.vo.weeks = selectedNodes[0].weekProperties
                _this.vo.roomStart = selectedNodes[0].beginTime
                _this.vo.roomEnd = selectedNodes[0].endTime
                _this.vo.numPeople = selectedNodes[0].numPeople

                //赋值父组件rowData值
                this.$vnode.context.rowData.meetPlace = selectedNodes[0].meetName
                this.$vnode.context.rowData.meetPlaceId = selectedNodes[0].id
            } else {
                this.updateMeetDirectoryIds(selectedNodes)
            }
        },
        onSelectSuborgCompleted(node, attr) {
            const names = []
            const ids = []
            node.forEach((item) => {
                names.push(item.name)
                ids.push(item.id)
            })
            if (attr.name === 'mainDept') {
                this.vo.mainDept = names.join('、')
                this.vo.mainDeptId = ids.join(',')
                this.$vnode.context.rowData.mainDept = this.vo.mainDept
                this.$vnode.context.rowData.mainDeptId = this.vo.mainDeptId
            }

            if (attr.name === 'attendName') {
                this.vo.attendName = names.join('、')
                this.vo.attendId = ids.join(',')
                this.bftzObj.attendName = names.join('、')
                this.bftzObj.attendId = ids.join(',')
                this.$vnode.context.rowData.attendName = this.vo.attendName
                this.$vnode.context.rowData.attendId = this.vo.attendId
            }
        },
        onSelectStaffCompleted(node, attr) {
            const names = []
            const ids = []
            node.forEach((item) => {
                names.push(item.name)
                ids.push(item.personId)
            })

            if (attr.name === 'attendName') {
                this.vo.attendName = names.join('、')
                this.vo.attendId = ids.join(',')
                const id = []
                node.forEach((item) => {
                    id.push(item.id)
                })
                this.bftzObj.attendName = names.join('、')
                this.bftzObj.attendId = id.join(',')
                this.$vnode.context.rowData.attendName = this.vo.attendName
                this.$vnode.context.rowData.attendId = this.vo.attendId
            }
            if (attr.name === 'meetHost') {
                this.vo.meetHost = names.join('、')
                this.vo.meetHostId = ids.join(',')
                this.$vnode.context.rowData.meetHost = this.vo.meetHost
                this.$vnode.context.rowData.meetHostId = this.vo.meetHostId
            }
            if (attr.name === 'externalPersonName') {
                this.vo.externalPersonName = names.join('、')
                this.vo.externalPersonId = ids.join(',')
            }
            if (attr.name === 'summaryName') {
                this.vo.summaryName = names.join('、')
                this.vo.summaryId = ids.join(',')
                this.vo.summaryPhone = node[0].mobile

                this.$vnode.context.rowData.summaryName = this.vo.summaryName
                this.$vnode.context.rowData.summaryId = this.vo.summaryId
                this.$vnode.context.rowData.summaryPhone = this.vo.summaryPhone
            }
            if (attr.name === 'attendLeader') {
                this.vo.attendLeader = names.join('、')
                this.vo.attendLeaderId = ids.join(',')

                this.$vnode.context.rowData.attendLeader = this.vo.attendLeader
                this.$vnode.context.rowData.attendLeaderId = this.vo.attendLeaderId
            }
            if (attr.name === 'sAttendName') {
                this.vo.sAttendName = names.join('、')
                this.vo.sAttendId = ids.join(',')
                this.$vnode.context.rowData.summaryId = this.vo.sAttendName
                this.$vnode.context.rowData.summaryPhone = this.vo.sAttendId
            }
        },
        datePickerChange(val) {
            console.log('val', val)

            if (val.length) {
                this.vo.startTime = val[0]
                this.vo.endTime = val[1]

                this.$vnode.context.rowData.startTime = val[0]
                this.$vnode.context.rowData.endTime = val[1]
            }
            console.log('this.vo', this.vo)
        },
        timeFormat(start, end) {
            const moment = require('moment')
            var sTime = moment(new Date(start)).format('YYYY年MM月DD日 HH:mm')
            var eTime = moment(new Date(end)).format('YYYY年MM月DD日 HH:mm')
            return sTime + '-' + eTime
        }
    }
}
</script>

<style scoped lang="scss">
.contQR {
    width: 372px;
    height: 500px;
    margin: 0 auto;
    h3,
    h4 {
        margin: 0;
    }
    img {
        width: 340px;
        height: 340px;
        margin: 0 auto;
    }
    p {
        margin: 0;
        padding: 0 40px;
    }
}
/deep/.el-range-editor--medium .el-range-separator {
    line-height: 35px !important;
    margin-right: 3px;
}
</style>
